module.exports = __webpack_public_path__ + "static/media/logo1024x1024.a17b6380.png";